var cov_dc4t96ili = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/dom/getDataset.ts",
      hash = "a9d3673f8561458c9fb294f7dace6d9b9e274866",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/dom/getDataset.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 2
        },
        end: {
          line: 3,
          column: 23
        }
      },
      "1": {
        start: {
          line: 3,
          column: 14
        },
        end: {
          line: 3,
          column: 23
        }
      },
      "2": {
        start: {
          line: 4,
          column: 15
        },
        end: {
          line: 4,
          column: 33
        }
      },
      "3": {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 9,
          column: 8
        }
      },
      "4": {
        start: {
          line: 6,
          column: 4
        },
        end: {
          line: 6,
          column: 58
        }
      },
      "5": {
        start: {
          line: 6,
          column: 48
        },
        end: {
          line: 6,
          column: 58
        }
      },
      "6": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 36
        }
      },
      "7": {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 14
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 16
          },
          end: {
            line: 2,
            column: 17
          }
        },
        loc: {
          start: {
            line: 2,
            column: 44
          },
          end: {
            line: 10,
            column: 1
          }
        },
        line: 2
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 5,
            column: 21
          },
          end: {
            line: 5,
            column: 22
          }
        },
        loc: {
          start: {
            line: 5,
            column: 84
          },
          end: {
            line: 9,
            column: 3
          }
        },
        line: 5
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 3,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 3,
            column: 23
          }
        }, {
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 3,
            column: 23
          }
        }],
        line: 3
      },
      "1": {
        loc: {
          start: {
            line: 6,
            column: 4
          },
          end: {
            line: 6,
            column: 58
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 6,
            column: 4
          },
          end: {
            line: 6,
            column: 58
          }
        }, {
          start: {
            line: 6,
            column: 4
          },
          end: {
            line: 6,
            column: 58
          }
        }],
        line: 6
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

//
export default (function (props) {
  cov_dc4t96ili.f[0]++;
  cov_dc4t96ili.s[0]++;

  if (!props) {
    cov_dc4t96ili.b[0][0]++;
    cov_dc4t96ili.s[1]++;
    return {};
  } else {
    cov_dc4t96ili.b[0][1]++;
  }

  var keys = (cov_dc4t96ili.s[2]++, Object.keys(props));
  cov_dc4t96ili.s[3]++;
  return keys.reduce(function (acc, key) {
    cov_dc4t96ili.f[1]++;
    cov_dc4t96ili.s[4]++;

    if (key.indexOf('data-') !== 0) {
      cov_dc4t96ili.b[1][0]++;
      cov_dc4t96ili.s[5]++;
      return acc;
    } else {
      cov_dc4t96ili.b[1][1]++;
    }

    cov_dc4t96ili.s[6]++;
    acc[key] = props[key];
    cov_dc4t96ili.s[7]++;
    return acc;
  }, {});
});